// extracted by mini-css-extract-plugin
export default {"results":"TokenList_results__TsGs+"};